import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button, SvgIcon, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { getAccessToken } from 'src/routes/AuthContext';

type Props = {};

function TherapistDashboardDocPreview(props: Props) {
  const { state } = useLocation();
  const getDashboardSignDoc = useSelector(
    (state: any) => state.getSignatureTemplateReducer.previewDashboardDoc
  );

  const [iframeRef, setIframeRef] = useState<any | null>(null);

  const updateIFrameRef = useCallback((node: any) => {
    setIframeRef(node);
  }, []);

  useEffect(() => {
    const iframeElement = iframeRef;

    if (iframeElement) {
      const interval = setInterval(async () => {
        const response = await getAccessToken();
      }, 15000);

      return () => {
        clearInterval(interval);
      };
    }
  }, [iframeRef]);

  return (
    <>
      <Stack
        gap="1.5rem"
        sx={{ padding: '0 4rem' }}
      >
        <Button
          sx={{
            justifyContent: 'flex-start',
            color: '#111927',
            width: 'max-content',
            padding: '0px',
          }}
          startIcon={
            <SvgIcon>
              <ArrowBackIcon sx={{ color: '#6C737F' }} />
            </SvgIcon>
          }
        >
          <Link
            style={{ color: '#111927' }}
            to={`${state?.source === 'PHYSICIAN' ? '/physician-dashboard' : '/dashboard'}`}
          >
            <Typography variant="subtitle1">Back to Dashboard</Typography>
          </Link>
        </Button>
        <Stack
          flexDirection="row"
          gap="1rem"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h5">
            Preview Document - {getDashboardSignDoc?.documentType}
          </Typography>
        </Stack>
      </Stack>
      <Box
        sx={{ height: '100%' }}
        p={3}
      >
        <iframe
          src={`${getDashboardSignDoc?.pdfUrl}`}
          width={'100%'}
          ref={updateIFrameRef}
          height={'100%'}
          style={{ border: 'none' }}
          title="this is preview document"
        />
      </Box>
    </>
  );
}

export default TherapistDashboardDocPreview;
